import type { PlayerSettings } from '@mogzo/game-ui';

const DEFAULTS: PlayerSettings = { sound: true, popups: true };
const key = (projectId: string) => `mogzo-game-settings:${projectId}`;

/** The player's choices in a game's pause menu, kept on this device. */
export function readGameSettings(projectId: string): PlayerSettings {
  try {
    const saved = JSON.parse(
      localStorage.getItem(key(projectId)) ?? '{}',
    ) as Partial<PlayerSettings>;
    return {
      sound: typeof saved.sound === 'boolean' ? saved.sound : DEFAULTS.sound,
      popups: typeof saved.popups === 'boolean' ? saved.popups : DEFAULTS.popups,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveGameSettings(projectId: string, settings: PlayerSettings) {
  try {
    localStorage.setItem(key(projectId), JSON.stringify(settings));
  } catch {
    // Storage blocked: the choice lasts until the page closes.
  }
}
